module.exports = __webpack_public_path__ + "img/247.343ef06e.png";